import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// 拦截器
axios.interceptors.response.use(function(response) {
  if (response.data.code === 0) {
    return response;
  }

  return Promise.reject(response.data)
}, function(error) {
  console.log(error)
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        console.log('401')
        break
    }
  }
  return Promise.reject(error.response.data)
})

// 图片上传接口
Vue.prototype.uploadserver = process.env.VUE_APP_UPLOAD_URL
// 图片服务器地址
Vue.prototype.imgserver = process.env.VUE_APP_IMAGE_URL

//全局定义axios
Vue.prototype.$http = axios

// eslint-disable-next-line
const _hmt = _hmt || [];
// eslint-disable-next-line
window._hmt = _hmt;
(function() {
  const hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?016aea1637a09747ef1a66214336510d";
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')